import instance from "../axiosConfig";
import { Keyword } from "./models/Keyword";

export class KeywordService {
    private regionCode: string;

    constructor(regionCode: string) {
        this.regionCode = regionCode;
    }

    get = async (elementId: string): Promise<Keyword[]> => {
        const response = await instance.get<Keyword[]>(`api/admin/${this.regionCode}/element/${elementId}/keywords`);

        return response.data;
    };

    create = async (elementId: string, body: Keyword): Promise<Keyword> => {
        const response = await instance.post<Keyword>(
            `api/admin/${this.regionCode}/element/${elementId}/keywords`,
            body,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    };

    update = async (elementId: string, keywordId: string, body: Keyword): Promise<Keyword> => {
        const response = await instance.put<Keyword>(
            `api/admin/${this.regionCode}/element/${elementId}/keywords/${keywordId}`,
            body,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    };

    delete = async (elementId: string, keywordId: string): Promise<boolean> => {
        const response = await instance.delete<Keyword>(
            `api/admin/${this.regionCode}/element/${elementId}/keywords/${keywordId}`
        );

        return response.status === 204;
    };
}
